<template>
	<el-container >
		<el-header class="title" >
			<el-row type="flex" align="middle">
				<el-col :span="22">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item >客户预约管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
		</el-header>
		<el-main>
			<el-table size="medium" :data="tableData" header-cell-class-name="table_header" :stripe="true" :height="tableHeight">
				<el-table-column prop="customer.name" label="客户姓名" width="120">
					<!--<template slot-scope="scope">-->
						<!--<el-button-->
							<!--@click.native.prevent="goToCustomerView(scope.row)"-->
							<!--type="text"-->
							<!--size="medium">{{scope.row.customer.name}}-->
						<!--</el-button>-->
					<!--</template>-->
				</el-table-column>
				<el-table-column prop="customer.phone" label="手机号" width="120">
				</el-table-column>
				<el-table-column prop="product.name" label="预约产品" width="270">
				</el-table-column>
				<el-table-column prop="productOpenDay.openTime" label="预约时间" width="180" :formatter="dateFormatter">
				</el-table-column>
				<el-table-column prop="createTime" label="提交时间" width="180">
				</el-table-column>
				<el-table-column prop="remark" label="留言内容">
					<template slot-scope="scope">
						<el-tooltip placement="top-start" popper-class="my-tooltip" :enterable="false" :content="scope.row.remark">
							<div class="remark-text">
								{{scope.row.remark}}
							</div>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
		</el-main>
		<div style="text-align:right;line-height: 40px;padding-top: 5px;background:#fff;">
			<el-pagination @current-change="currentPageChangeHandler" background layout="total,prev, pager, next" :total="total" :page-size="pageSize">
			</el-pagination>
		</div>
	</el-container>
</template>

<script>
	import config from "../../../config/global.js";
	import axios from "axios"

	var getCustomerOrderUrl = "/backend/product/openday/getcustomerlist.json";
    export default {
        name: "customer-order-query",
			data(){
        	return {
						tableData: [],
						total:0,
						pageSize:200,
						currentPageIndex:1,
						tableHeight:window.innerHeight-170+"px",
					}
			},
			methods:{
				dateFormatter:function (row, column,value) {
					if(value == null || value.length<10)
						return;
					return value.substring(0,10);
				},
				queryCustomerOrders(){
					var start = Math.max(0,(this.currentPageIndex-1)*this.pageSize);
					var size = this.pageSize;
					axios({
						method: 'get',
						url:config.host+getCustomerOrderUrl+"?productid="+"&date=",
						data:{start,size,name:this.searchKey}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.tableData = response.data.items
						this.total = response.data.total
					})
						.catch((error)=>{
							console.log(error)
						})
				},
				topage(pageIndex){
					this.query((pageIndex-1)*this.pageSize,this.pageSize)
				},
				currentPageChangeHandler:function (val) {
					this.currentPageIndex = val;
					this.queryCustomerOrders();
				},
			},
			mounted:function(){
				this.queryCustomerOrders();
			}
    }
</script>

<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}

	.remark-text{
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/customerorder/CustomerOrderQuery.vue